import { ComponentChildren, ComponentProps, JSX } from 'preact'
import { forwardRef } from 'preact/compat'

declare global {
  // eslint-disable-next-line @typescript-eslint/no-namespace,@typescript-eslint/no-unused-vars
  namespace preact.createElement.JSX {
    interface IntrinsicElements {
      'getsitecontrol-widget': preact.JSX.HTMLAttributes<HTMLDivElement>
    }
  }
}

export interface HostProps extends ComponentProps<'getsitecontrol-widget'> {
  children: ComponentChildren
}

export const Host = forwardRef<HTMLDivElement, HostProps>(function Host(props, ref) {
  const { children, ...rest } = props
  return (
    <getsitecontrol-widget {...rest} ref={ref}>
      {children}
    </getsitecontrol-widget>
  )
})
